import { render, staticRenderFns } from "./SupplireRuleForm.vue?vue&type=template&id=39b65f73&"
import script from "./SupplireRuleForm.vue?vue&type=script&lang=js&"
export * from "./SupplireRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplireRuleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports